import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">Kevin Adams</Link>
            <p className="footer__tagline">Mayor of Horseheads</p>
          </div>

          <div className="footer__nav">
            <Link to="/">Home</Link>
            <Link to="/vision">Vision</Link>
            <Link to="/qualifications">About</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer__contact">
            <a href="mailto:concerns@kevindadams.com">concerns@kevindadams.com</a>
            <a href="tel:+16073980783">(607) 398-0783</a>
          </div>
        </div>

        <div className="footer__bottom">
          <p>
            &copy; 2026 Kevin Adams. All rights reserved.
            <span className="footer__watermark">
              {' · Made by '}
              <a
                href="https://shawnymedia.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                ShawnyMedia
              </a>
            </span>
          </p>
          <div className="footer__socials">
            <a
              href="https://www.facebook.com/KevinAdamsNY/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social"
              aria-label="Facebook"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/in/kevinadams313/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social"
              aria-label="LinkedIn"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.37V9h3.41v1.56h.05c.47-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45C23.2 24 24 23.23 24 22.28V1.72C24 .77 23.2 0 22.22 0z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
